module.exports = __webpack_public_path__ + "img/technology@2x.a30e7b8d.png";